import axios from "axios";

// Get the backend URL from environment variables
const backendDomain = process.env.REACT_APP_BACKEND_URL || "https://akbe.jpworld.cloud/api/";

const axiosInstance = axios.create({
  baseURL: backendDomain,
  headers: {
    "Content-Type": "application/json",
  },
});


const BlogApi = {
  // Method to fetch the blog content
  getBlogContent: () => axiosInstance.get("/home/home-content"),
};


const CarouselApi = {
  // Method to fetch the carousel content
  getCarouselContent: () => axiosInstance.get("/home/home-content"),
}; 


const FooterApi = {
  // Method to fetch the footer content
  getFooterContent: () => axiosInstance.get("/footer/footer-content"),
};

const HomeApi = {
  // Method to fetch home content
  getHomeContent: () => axiosInstance.get("/home/home-content"),
};


const AboutApi = {
  // Method to fetch about page content
  getAboutContent: () => axiosInstance.get("/about/about-us"),
};

// Define API methods related to contact page
const ContactApi = {
  // Method to fetch contact page content
  getContactContent: () => axiosInstance.get("/contact-app/contact"),

  // Method to submit contact form
  submitContactForm: (formData) => 
    axiosInstance.post("/forms/contact_us", formData),

  // Method to submit appointment form
  submitAppointmentForm: (formData) => 
    axiosInstance.post("/forms/book_an_appointment", formData),
};


const HairCareApi = {
  // Method to fetch hair care content
  getHairCareContent: () => axiosInstance.get("/hair/haircare"),
};

const SkinCareApi = {
  // Method to fetch skin care content
  getSkinCareContent: () => axiosInstance.get("/skin/skincare"),
};

export { BlogApi, CarouselApi, FooterApi, HomeApi , AboutApi, ContactApi, HairCareApi, SkinCareApi};
